import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.notification}owners/${COMMON_QUERY_PARAMS.OWNER_ID}/backOfficeLink`;

export interface CreateTinyAuthenticatedUrlCommandPayload {
  ownerId: string;
  orderId?: string;
  fileId?: string;
  tenantId?: string;
  redirectUrl?: string;
  tokenOrigin?: string;
  ticketId?: string;
  sellerId?: string;
  forceLocalhost?: boolean;
  forceRedirectUrl?: boolean;
}

export const createTinyAuthenticatedUrlRequest = (
  payload: CreateTinyAuthenticatedUrlCommandPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.OWNER_ID, payload.ownerId),
  config: { method: SUPPORTED_METHODS.POST, json: payload },
});

export const createTinyAuthenticatedUrlCommand = async (
  payload: CreateTinyAuthenticatedUrlCommandPayload,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      createTinyAuthenticatedUrlRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
